import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';

import RCore from 'RCore';
import eventify from 'Eventify';
import SMTeamLogo from '../SMTeamLogo';
import DateFormatted from '../DateFormatted';

const i18Common = require('../../../../i18/i18.Common');

const i18 = RCore.getTranslation.bind({ dict: i18Common });

import { Container, Rows } from './H2HTableSimple';

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const LogoWrapper = styled.div`
    text-align: center;
    width: calc(50% - 60px);
`;

const StartInfo = styled.div`
    text-align: center;

    .time {
        font-size: 38px;
        line-height: 40px;
        font-weight: 700;
        margin-top: 4px;
        margin-bottom: 4px;
    }

    .tournament {
        overflow: hidden;
        max-width: 120px;
        margin: 0 auto;
        text-transform: uppercase;
        font-size: 16px;
        line-height: 18px;
        font-weight: 700;

        svg {
            height: 13px;

            color: ${props => props.theme.color};
            fill: ${props => props.theme.color};
        }
    }

    .channel {
        font-size: 16px;
        line-height: 18px;
        white-space: nowrap;
    }
`;

const Team = styled.div`
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    width: calc(50% - 60px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 10px;
`;

const RowsWrapper = styled.div`
    margin-top: 20px;

    .stat-row {
        background: transparent;
        position: relative;
        padding: 6px 0;
        justify-content: space-between;

        .val {
            color: ${props => props.theme.statTableTextColor};
        }
        .val {
            width: calc(50% - 60px);
            text-align: center;
            flex-basis: initial;
            flex-grow: initial;
            &.tar {
                text-align: center;
            }
        }
        .label {
            font-size: 20px;
            font-weight: 400;
            width: auto;
            padding: 0;
            position: absolute;
            min-width: 1px;
            overflow: visible;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: ${props => props.theme.statTableLabelTextColor};
        }
    }
`;

const EventInfo = styled.div`
    height: 60px;
    line-height: 60px;
    background: ${props => props.theme.content.backgroundColor};
`;

const LatestFormRow = () => null;
const H2HRow = () => null;

const WrappedRows = props => {
    return (
        <RowsWrapper>
            <Rows {...props} />
        </RowsWrapper>
    );
};

const Header = ({ event }, ctx) => {
    const {
        homeName,
        awayName,
        homeId,
        awayId,
        score: { home, away },
        statusType,
    } = event;
    const lang = _.get(ctx, 'info.lang', 'en');
    event = eventify(event);

    const isNotStarted = statusType === 'notstarted';

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <Flex>
                    <LogoWrapper>
                        <SMTeamLogo height={120} fontSize={42} teamId={homeId} teamShortName={event.homeShortName} />
                    </LogoWrapper>
                    <LogoWrapper>
                        <SMTeamLogo height={120} fontSize={42} teamId={awayId} teamShortName={event.awayShortName} />
                    </LogoWrapper>
                </Flex>
            </div>
            <EventInfo>
                <Flex>
                    <Team>
                        <span>{homeName}</span>
                    </Team>
                    {isNotStarted && (
                        <StartInfo>
                            <DateFormatted className="time" el="span" date={event.startDate} type="TIME" />
                            {event.channel && <div className="channel">{event.channel.name}</div>}
                        </StartInfo>
                    )}
                    {/*{event.isLive() || event.isFinished() ? (
                        <Divider>
                            {home} : {away}
                        </Divider>
                    ) : (
                        <Divider className="empty" />
                    )}*/}
                    <Team>
                        <span>{awayName}</span>
                    </Team>
                </Flex>
            </EventInfo>
        </div>
    );
};

Header.contextTypes = {
    info: PropTypes.object,
};

const HeaderMinimized = Header;

export default {
    Container,
    Header,
    HeaderMinimized,
    LatestFormRow,
    Rows: WrappedRows,
    H2HRow,
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/h2h/H2HTableStyle3.js
 **/